import React, { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import logo from '../../assets/images/origin-white.png';

import { FaUserCircle } from 'react-icons/fa';

const Header = () => {
  const { username } = useContext(AuthContext);
  return (
    <div className="min-w-full h-16 bg-primary-500 flex items-center justify-between px-4 text-white">
      <div className="flex items-center space-x-4">
        <img src={logo} alt="" className="h-12" />
        <span className="text-2xl">DNRME Reports Generator</span>
      </div>
      <div className="flex items-center space-x-4">
        <FaUserCircle size="2rem"></FaUserCircle>
        <span className="text-xl">{username}</span>
      </div>
    </div>
  );
};

export default Header;
